export default __webpack_public_path__ + "static/media/6.286233d7.png";